import { EndPointService } from '../api-handlers/axios';

export interface AppVersionData {
    id?: number;
    androidVersion: string;
    iosVersion: string;
    versionCode: number;
    isMandatory: boolean;
    isActive?: boolean;
    updateUrlIos?: string;
    updateUrlAndroid?: string;
    iosStoreUrl?: string;
    androidStoreUrl?: string;
    latestVersion?: string;
    minimumSupportedVersion?: string;
    updatedAt?: string;
    createdAt?: string;
}

export interface UserDeviceData {
    id: string;
    uniqueId: string;
    os: string;
    appVersion?: string;
    versionCode?: number;
    deviceModel?: string;
    updatedAt?: string;
}

export interface UserAppVersionItem {
    id: string;
    fullName: string;
    email: string;
    photo?: string | null;
    status: number;
    platform?: string | null;
    appVersion?: string | null;
    versionCode?: number | null;
    versionStatus: 'UP_TO_DATE' | 'NEEDS_UPDATE' | 'MANDATORY_UPDATE' | 'NOT_RECORDED';
    isLatest: boolean;
    deviceModel?: string | null;
    deviceCount: number;
    devices: UserDeviceData[];
    lastActiveAt?: string | null;
    createdAt: string;
}

export interface VersionDistributionItem {
    version: string;
    androidVersion?: string;
    iosVersion?: string;
    versionCode?: number;
    count: number;
    percentage: number;
    androidCount: number;
    iosCount: number;
}

export interface UserAppVersionSummary {
    totalUsers: number;
    trackedAppUsers: number;
    upToDateUsers: number;
    outdatedUsers: number;
    androidUsers: number;
    iosUsers: number;
    unknownUsers?: number;
    latestAndroidVersion: string;
    latestIosVersion: string;
    latestVersionCode: number;
    isMandatory: boolean;
    versionDistribution?: VersionDistributionItem[];
}

export interface UserAppVersionListResponse {
    items: UserAppVersionItem[];
    page: number;
    limit: number;
    totalPages: number;
    totalCount: number;
    summary: UserAppVersionSummary;
}

const AppVersionApi = {
    get: () => EndPointService.get('/app-version'),
    list: (params?: any) => EndPointService.get('/app-version/list', params),
    update: (data: AppVersionData) => EndPointService.put('/app-version', data),
    listUserVersions: (params?: any) => EndPointService.get<UserAppVersionListResponse>('/user-app-versions', params),
    exportUserVersions: (params?: any) =>
        EndPointService.get<UserAppVersionListResponse>('/user-app-versions', {
            ...params,
            export: true,
            limit: 100000,
        }),
};

export default AppVersionApi;
